import { Grid } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { SmartContract, validationsMessages } from '../../../../lib';
import { JobManagerChainSelector } from '../job-manager-chain-selector/JobManagerChainSelector';
import { JobManagerSmartContractSelector } from '../job-manager-smart-contract-selector/JobManagerSmartContractSelector';
import {
    ExecuteSmartContractJobFormInputs,
    executeSmartContractJobStyles,
} from './create-execute-smart-contract-job-helper';

interface JobBasicInfoFormProps {
    control: Control<ExecuteSmartContractJobFormInputs, any>;
    errors: FieldErrors<ExecuteSmartContractJobFormInputs>;
    onChainChange: (value: string) => void;
    onSmartContractChange: (value: SmartContract) => void;
    selectedChain: string;
    selectedSmartContract: SmartContract | null;
    smartContractFieldValue?: SmartContract | null;
}

export const BasicInfoForm = ({
    control,
    errors,
    onChainChange,
    onSmartContractChange,
    selectedChain,
    selectedSmartContract,
    smartContractFieldValue,
}: JobBasicInfoFormProps): React.JSX.Element => {
    return (
        <Grid sx={executeSmartContractJobStyles.basicInfoFormContainer}>
            <Grid sx={executeSmartContractJobStyles.basicInfoFormItemContainer}>
                <Controller
                    name='chain'
                    control={control}
                    render={(): React.JSX.Element => (
                        <JobManagerChainSelector
                            defaultValue={selectedChain}
                            onChange={(__, value): void => onChainChange(value)}
                            required={true}
                            error={!!errors.chain}
                            errorText={
                                errors.chain ? validationsMessages.required : ''
                            }
                        />
                    )}
                />
            </Grid>
            <Grid sx={executeSmartContractJobStyles.basicInfoFormItemContainer}>
                <Controller
                    name='smartContract'
                    control={control}
                    render={(): React.JSX.Element => (
                        <JobManagerSmartContractSelector
                            chain={selectedChain}
                            defaultValue={selectedSmartContract}
                            onChange={(__, value): void =>
                                onSmartContractChange(value)
                            }
                            value={smartContractFieldValue}
                            required={true}
                            error={!!errors.smartContract}
                            errorText={
                                errors.smartContract
                                    ? validationsMessages.required
                                    : ''
                            }
                        />
                    )}
                />
            </Grid>
        </Grid>
    );
};
